import React, { useEffect, useRef, useState } from "react";
import { Button, TextField, Select, MenuItem } from '@mui/material';
import Avatar from '@material-ui/core/Avatar';
import Card from '@mui/material/Card';
import { useDataProvider } from "../../api/DataProvider";
import { useCommProvider } from "../../api/CommProvider";
import { profileValidator } from "../../api/utils/validator";
import { pDialogProfileTab } from "../../utils/parameters";
import HelpSnackbar from "../utils/HelpSnackbar";
import SaveIcon from '@mui/icons-material/Save';
import device from "current-device";
import "../../styles/devices/mob_UserProfile.css";
import { useTranslation } from "react-i18next";


export function DialogEditProfile(props) {

  const [snack, setSnack] = useState({ open: false, text: "" });
  const { t } = useTranslation("global")

  const { setTabValue, profileData, setProfileData } = props;
  const { token_id, currentUser, json_data_USER, set_json_data_USER } = useDataProvider();
  const { comm_updateProfile } = useCommProvider();
  
  const img_user_ref = useRef(profileData['img_user']);
  const isPublic_ref = useRef(profileData['isPublic']);

  // TextFields
  const name_ref = useRef(profileData['name']);
  const sex_ref = useRef(profileData['sex']);
  const age_ref = useRef(profileData['age']);
  const zip_code_ref = useRef(profileData['zip_code']);
  const level_ref = useRef(profileData['level']);
  const school_ref = useRef(profileData['school']);
  const address_ref = useRef(profileData['address']);

  // SelectFields
  const [isPublicSelect, setIsPublicSelect] = useState(profileData['isPublic']);
  const [sexSelect, setSexSelect] = useState(profileData['sex']);
  const [levelSelect, setLevelSelect] = useState(profileData['level']);
  const [isLSESelect, setIsLSESelect] = useState(profileData['isLSE']);
  const [changedFields, setChangedFields] = useState({});
  const [isNameSelected, setIsNameSelected] = useState(false); // Minimun field required to enable Private/Public selection

  useEffect(() => {
    // console.log("🚀 ~ file: DialogEditProfile.js:54 ~ DialogEditProfile ~ profileData:", profileData)
    if (profileData['name'] !== '') {
      setIsNameSelected(true);
    }else{
      setIsNameSelected(false);
    }
  }, [profileData]);


  // useEffect(() => {
  //   console.log("🚀 ~ file: DialogEditProfile.js:54 ~ DialogEditProfile ~ changedFields:", changedFields)
  // }, [changedFields]);

  async function handleSendProfile(e) {
    const response = profileValidator(profileData, changedFields)
    if (response !== '') {   // Si retorna algo diferente a null es un error de validación y no se envía el formulario
      // enqueueSnackbar('No ha sido posible realizar la actualización del perfil. Motivo: ' + response, { variant: "warning" });
      setSnack({ ...snack, open: true, text: "No ha sido posible realizar la actualización del perfil. \n Motivo: " + response, type: "error" , autoHideDuration: 4000});
      return;
    }else{

      try{
        const profile_updated = await comm_updateProfile(token_id, currentUser, changedFields);
        props.setProfileModified(false);
        props.setSaveAndClose(false);
        set_json_data_USER({ ...json_data_USER, profile: profile_updated });
        setTabValue(pDialogProfileTab.info);
      }catch(err){
          console.error(err)
      }

    }
  };

  useEffect(() => {
    console.log("saveAndClose: ", props.saveAndClose)
    if (props.saveAndClose) {
      handleSendProfile();
    }
  }, [props.saveAndClose]);

  const handleFocus = (event) => {
    if (device.type !== 'desktop') {
        const el = event.target.closest('.sig_ProfileModal_Line');
        //el.classList.add('sig_FocusedInputField');
        el.scrollIntoView({behavior: "smooth"});
    }
  }

  const handleBlur = (event) => {
    //const el = event.target.closest('.sig_ProfileModal_Line');
    //el.classList.remove('sig_FocusedInputField');
  }

  const handleChange = (event, fieldName) => {
    const selectedValue = event.target.value;
    switch (fieldName) {
      case 'name':
        if (selectedValue.length > 2 ) {
          setIsNameSelected(true)
        }else{
          setIsNameSelected(false);
        }
        break;
      case 'isPublic':
        setIsPublicSelect(selectedValue);
        break;
      case 'sex':
        setSexSelect(selectedValue);
        break;
      case 'level':
        setLevelSelect(selectedValue);
        break;
      case 'isLSE':
        setIsLSESelect(selectedValue);
        break;
    }

    setChangedFields((prevChangedFields) => {
      if (selectedValue === profileData[fieldName]) {
        // Si son iguales, crea un nuevo objeto sin la entrada [fieldName]
        const { [fieldName]: _, ...rest } = prevChangedFields;
        return rest;
      } else {
        // Si no son iguales, agrega o actualiza la entrada en el objeto changedFields
        props.setProfileModified(true);
        return { ...prevChangedFields, [fieldName]: selectedValue };
      }
    });
  };

  return (
      <>
          <Card>
            <div className='sig_ProfileInfo_Root'>
              <div className='sig_ProfileInfo_MainContainer'>
                {/* <div className='sig_Profile_AvatarContainer'>
                  <div className="sig_Profile_Avatar">
                    <Avatar alt="User profile picture" src={img_user_ref.current.value} className="sig_Profile_circular_img" />
                  </div>
                </div> */}
                <div className='sig_ProfileModal_Line'>
                  <div className="sig_SignModal_PaperTitle">
                    {!isNameSelected ?
                        <span style={{color: 'red', textAlign: 'right', display: 'block'}}> {t("sProfile.warning_need_name_nick")} </span>
                      :
                        <></>
                    }
                  <span> {t("sProfile.name")} </span>
                    
                  </div>
                  <div className="sig_SignModal_PaperBody">
                    <TextField 
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={name_ref}
                      defaultValue={profileData['name']}
                      className="sig_SignModal_PaperBody"
                      onFocus={(e) => handleFocus(e)}
                      onBlur={(e) => handleBlur(e)}
                      onChange={(e) => handleChange(e, 'name')}
                    />
                  </div>
                </div>
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.isPublic")}</div>
                  <div className="sig_SignModal_PaperBody">
                    <Select 
                      fullWidth
                      size="small"
                      inputRef={isPublic_ref}
                      value={isPublicSelect}
                      disabled={!isNameSelected}
                      onChange={(e) => handleChange(e, 'isPublic')}
                    >
                      <MenuItem value={true}> {t("sProfile.public")} </MenuItem>
                      <MenuItem value={false}> {t("sProfile.private")} </MenuItem>
                    </Select>
                  </div>     
                </div>
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.sex")}</div>
                  <div className="sig_SignModal_PaperBody">

                    <Select 
                      inputRef={sex_ref}
                      fullWidth
                      size="small"
                      value={sexSelect}
                      disabled={!isNameSelected}
                      onChange={(e) => handleChange(e, 'sex')}
                      label= {t("strButton.options")}
                    >
                      <MenuItem value=""><em>&nbsp;</em></MenuItem>
                      <MenuItem value="MUJER"> {t("sProfile.sex_woman")} </MenuItem>
                      <MenuItem value="HOMBRE"> {t("sProfile.sex_man")} </MenuItem>
                      <MenuItem value="No especificado"> {t("sProfile.sex_none")} </MenuItem>
                    </Select>
                  </div>
                </div>
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.age")}</div>
                  <div className="sig_SignModal_PaperBody">
                    <TextField 
                      variant="outlined"
                      size="small"
                      type="number"
                      fullWidth
                      inputRef={age_ref}
                      disabled={!isNameSelected}
                      inputProps={{ min: 0, max: 100, step: 1 }}
                      defaultValue={profileData['age']}
                      onFocus={(e) => handleFocus(e)}
                      onBlur={(e) => handleBlur(e)}
                      onChange={(e) => handleChange(e, 'age')}
                    />
                  </div>
                </div>
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.address")}</div>
                  <div className="sig_SignModal_PaperBody">
                    <TextField 
                      variant="outlined"
                      size="small"
                      inputRef={address_ref}
                      defaultValue={profileData['address']}
                      multiline
                      maxRows={4}
                      disabled={!isNameSelected}
                      onFocus={(e) => handleFocus(e)}
                      onBlur={(e) => handleBlur(e)}
                      onChange={(e) => handleChange(e, 'address')}
                    />
                  </div>
                </div> 
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.level")}</div>
                  <div className="sig_SignModal_PaperBody">
                  <Select 
                      inputRef={level_ref}
                      fullWidth
                      size="small"
                      value={levelSelect}
                      disabled={!isNameSelected}
                      onChange={(e) => handleChange(e, 'level')}
                      label= {t("strButton.options")}
                    >
                      <MenuItem value=""><em>&nbsp;</em></MenuItem>
                      <MenuItem value="SORDO"> {t("sProfile.level_deaf")} </MenuItem>
                      <MenuItem value="CODA"> {t("sProfile.level_CODA")} </MenuItem>
                      <MenuItem value="ILSE"> {t("sProfile.level_ILSE")} </MenuItem>
                      <MenuItem value="ESTUDIANTE"> {t("sProfile.level_student")} </MenuItem>
                      <MenuItem value="OTRO"> {t("sProfile.level_other")} </MenuItem>
                    </Select>
                  </div>
                </div>
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.school")}</div>
                  <div className="sig_SignModal_PaperBody">
                    <TextField 
                      variant="outlined"
                      size="small"
                      inputRef={school_ref}
                      defaultValue={profileData['school']}
                      multiline
                      maxRows={4}
                      disabled={!isNameSelected}
                      onFocus={(e) => handleFocus(e)}
                      onBlur={(e) => handleBlur(e)}
                      onChange={(e) => handleChange(e, 'school')}
                    />
                  </div>
                </div>  
                <div className='sig_ProfileModal_Line'>
                  <div className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}>{t("sProfile.zip_code")}</div>
                  <div className="sig_SignModal_PaperBody">
                    <TextField 
                      variant="outlined"
                      size="small"
                      inputRef={zip_code_ref}
                      disabled={!isNameSelected}
                      defaultValue={profileData['zip_code']}
                      onFocus={(e) => handleFocus(e)}
                      onBlur={(e) => handleBlur(e)}
                      onChange={(e) => handleChange(e, 'zip_code')}
                    />
                  </div>
                </div>   
                <Button className={`sig_SignDialog_Button sig_SignDialog_ButtonRecord ${isNameSelected ? "" : "sig_SignDialog_ButtonDisabled"}`} disabled={Object.keys(changedFields).length == 0} onClick={handleSendProfile}>
                  <SaveIcon className="sig_Account_Icon"/>
                    {t("sProfile.save_changes").toUpperCase()}
                </Button>
              </div>
            </div>
          </Card>
          <HelpSnackbar snack={snack} setSnack={setSnack} />
        </>
  );
}



// className={`sig_SignModal_PaperTitle ${isNameSelected ? "" : "sig_SignModal_PaperTitleDisabled"}`}